/* eslint-disable prettier/prettier */
import { emojiIconMap } from '../../utils/emojiIconMap';
import { CollapsibleSection } from '../file/CollapsibleSection';
import { ComparisonTable } from './ComparisonTable';

export const CedantsComparisonSection = ({
  cedants,
  showDifferences,
}: {
  cedants?: any[];
  showDifferences?: boolean;
}) => {
  if (!Array.isArray(cedants)) return null;

  const cedantHasDifferences = (cedant: any) =>
    Object.values(cedant).some(
      (val) =>
        typeof val === 'object' && val !== null && 'isDifferent' in val && val.isDifferent === true,
    );

  const filteredCedants = showDifferences ? cedants.filter(cedantHasDifferences) : cedants;

  if (filteredCedants.length === 0) return null;

  return (
    <CollapsibleSection title="Cedants" icon={emojiIconMap['Cedants']}>
      {filteredCedants.map((cedant, index) => {
        const dataToShow = showDifferences
          ? Object.fromEntries(
              Object.entries(cedant).filter(
                ([_, val]) =>
                  typeof val === 'object' && val !== null && (val as any).isDifferent === true,
              ),
            )
          : cedant;

        return (
          <div key={index} className="mb-4">
            <ComparisonTable
              data={dataToShow}
              fieldLabels={{
                id: 'ID',
                name: 'Name',
                country: 'Country',
                location: 'Location',
              }}
              firstLabel={`Cedant ${index + 1}`}
              showDifferences={showDifferences}
            />
          </div>
        );
      })}
    </CollapsibleSection>
  );
};
